import { api } from "../api";


export async function inspectActivationInvite(token) {
  const response = await api.post("/api/onboarding/invitations/inspect", { token });
  return response.data;
}


export async function redeemActivationInvite(payload) {
  const response = await api.post("/api/onboarding/invitations/redeem", payload);
  return response.data;
}


export async function issueActivationInvite(payload) {
  const response = await api.post("/api/onboarding/admin/invitations", payload);
  return response.data;
}


export async function getTrialStatus() {
  const response = await api.get("/api/secure/trial/status");
  return response.data;
}


export async function completeGuidedSample() {
  const response = await api.post("/api/secure/trial/sample-complete");
  return response.data;
}


export function onboardingErrorMessage(error, fallback) {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (detail?.message) return detail.message;
  return error?.message || fallback;
}
